import api from "./fr-FR/api";
import appName from "./fr-FR/appName";
import attendanceCards from "./fr-FR/attendanceCards";
import attendanceOptions from "./fr-FR/attendanceOptions";
import attendanceTypes from "./fr-FR/attendanceTypes";
import auth from "./fr-FR/auth";
import billing from "./fr-FR/billing";
import chat from "./fr-FR/chat";
import common from "./fr-FR/common";
import contacts from "./fr-FR/contacts";
import dashboard from "./fr-FR/dashboard";
import displayMessages from "./fr-FR/displayMessages";
import eventTimeline from "./fr-FR/eventTimeline";
import financial from "./fr-FR/financial";
import functions from "./fr-FR/functions";
import guides from "./fr-FR/guides";
import home from "./fr-FR/home";
import import_ from "./fr-FR/import";
import journeyStages from "./fr-FR/journeyStages";
import landing from "./fr-FR/landing";
import landingHome from "./fr-FR/landingHome";
import memberGroup from "./fr-FR/memberGroup";
import memberHistory from "./fr-FR/memberHistory";
import membersAssignments from "./fr-FR/membersAssignments";
import mfa from "./fr-FR/mfa";
import menu from "./fr-FR/menu";
import navigation from "./fr-FR/navigation";
import notFound from "./fr-FR/notFound";
import onboarding from "./fr-FR/onboarding";
import orixas from "./fr-FR/orixas";
import pagination from "./fr-FR/pagination";
import people from "./fr-FR/people";
import personGuides from "./fr-FR/personGuides";
import personMessage from "./fr-FR/personMessage";
import personReturn from "./fr-FR/personReturn";
import persons from "./fr-FR/persons";
import profile from "./fr-FR/profile";
import registerInvite from "./fr-FR/registerInvite";
import registerTemple from "./fr-FR/registerTemple";
import reports from "./fr-FR/reports";
import ritualAttendance from "./fr-FR/ritualAttendance";
import ritualClosing from "./fr-FR/ritualClosing";
import ritualTypes from "./fr-FR/ritualTypes";
import rituals from "./fr-FR/rituals";
import ritualReservations from "./fr-FR/ritualReservations";
import spiritualLines from "./fr-FR/spiritualLines";
import support from "./fr-FR/support";
import table from "./fr-FR/table";
import temple from "./fr-FR/temple";
import agendaPublica from "./fr-FR/agendaPublica";
import themes from "./fr-FR/themes";
import ticketCall from "./fr-FR/ticketCall";
import tickets from "./fr-FR/tickets";
import tours from "./fr-FR/tours";
import users from "./fr-FR/users";
import ownershipTransfer from "./fr-FR/ownershipTransfer";
import validation from "./fr-FR/validation";
import phoneField from "./fr-FR/phoneField";
import verifyEmail from "./fr-FR/verifyEmail";
import wisdomQuotes from "./fr-FR/wisdomQuotes";
import session from "./fr-FR/session";

export default {
	relatedEntityCreation: {
		createSpiritualLine: "+ Créer une Ligne Spirituelle",
		createGuide: "+ Créer un Guide",
		createAttendanceType: "+ Créer un Type de Consultation",
		createRitualType: "+ Créer un Type de Rituel",
		createMedium: "+ Créer un Médium",
	},
	appName,
	api,
	attendanceCards,
	attendanceOptions,
	attendanceTypes,
	auth,
	billing,
	chat,
	common,
	contacts,
	dashboard,
	displayMessages,
	eventTimeline,
	financial,
	functions,
	guides,
	home,
	import: import_,
	journeyStages,
	landing,
	landingHome,
	memberGroup,
	memberHistory,
	membersAssignments,
	mfa,
	menu,
	navigation,
	notFound,
	onboarding,
	orixas,
	pagination,
	people,
	personGuides,
	personMessage,
	personReturn,
	persons,
	profile,
	registerInvite,
	registerTemple,
	reports,
	ritualAttendance,
	ritualClosing,
	ritualTypes,
	rituals,
	ritualReservations,
	spiritualLines,
	support,
	table,
	temple,
	agendaPublica,
	themes,
	ticketCall,
	tickets,
	tours,
	users,
	ownershipTransfer,
	validation,
	phoneField,
	verifyEmail,
	wisdomQuotes,
	session,
};
